import { GetFeaturePermission } from "./appsession";

// User Activity Log: who is calling and from which menu / page, sent with every API call. Read at call time
// (not from the LocalStorage snapshot), so they are right straight after login and after each navigation.
export const ActivityHeader = {
  UserId: "X-User-Id",
  SessionId: "X-Session-Id",
  FeatureId: "X-Feature-Id",
  PagePath: "X-Page-Path",
};

/** The activity headers of the logged-in user, or {} when nobody is logged in. */
export const activityHeaders = (
  storage = sessionStorage,
  path = window.location.pathname,
  featureOf = () => GetFeaturePermission()?.featureId,
) => {
  const userId = Number(storage.getItem("session_userid"));
  if (!userId) return {};
  let featureId = null;
  try {
    featureId = featureOf();
  } catch {
    featureId = null;
  }
  const headers = {
    [ActivityHeader.UserId]: String(userId),
    [ActivityHeader.PagePath]: encodeURI(path || "/"),
  };
  const sessionId = storage.getItem("session_authtoken");
  if (sessionId) headers[ActivityHeader.SessionId] = sessionId;
  if (featureId) headers[ActivityHeader.FeatureId] = String(featureId);
  return headers;
};
